import React from "react";
import GameInstructionModal from "./GameInstructionModal";

const ModalSearchQuest = ({ isOpen, onRequestClose }) => {
  return (
    <GameInstructionModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title="Search Quest"
      gamePath="/userDashboard/game/search-latter"
      icon="solar:magnifer-bold"
      instructions={[
        "Patch your better eye.",
        "Locate the target letter (shown at the bottom) inside the grid of random letters.",
        "Click on the matching letter to score points."
      ]}
      isBinocular={false}
    />
  );
};

export default ModalSearchQuest;
